// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__DZwVB","select":"Header_select__3ZZhH","clinic":"Header_clinic__2UCv3"};